<template>
    <div @mouseenter="onHoverStart" @mouseleave="onHoverEnd" class="slider-item" :class="['slider-item-' + (iterator + 1), {'top-ten-item': section === 'tmu'}]">
      <casino-labels class="casino-labels" v-if="gameInfoData && gameInfoData.labels && gameInfoData.labels.length > 0" :labels="gameInfoData.labels"></casino-labels>
      <casino-favorites v-if="isLoggedIn" :favorite="isFavorite" :gameId="gameId"></casino-favorites>
      <casino-game-image :gameId="gameId"></casino-game-image>
      <div :class="[{'top-ten': section === 'tmu'}, 'top-' + (iterator + 1), 'top-image']" v-if="section && section === 'tmu'" @click="startCasinoLauncher(gameId)"></div>
      <casino-jackpot-and-game-info-section :gameId="gameId" :section="section"></casino-jackpot-and-game-info-section>
    </div>
</template>

<script>
import CasinoGameImage from '@/components/igaming/partials/casinoGameImage.vue'
import CasinoJackpotAndGameInfoSection from '@/components/igaming/partials/casinoJackpotAndGameInfoSection.vue'
import CasinoLabels from '@/components/igaming/partials/casinoLabels.vue'
import CasinoFavorites from '@/components/igaming/partials/casinoFavorites.vue'
import Casino from '@/components/mixins/Casino'
import store from '@/store'
export default {
  name: 'casinoSliderItem',
  props: ['gameId', 'iterator', 'section', 'gameInfoData', 'isFavorite'],
  mixins: [
    Casino
  ],
  components: {
    CasinoGameImage,
    CasinoJackpotAndGameInfoSection,
    CasinoLabels,
    CasinoFavorites
  },
  data () {
    return {}
  },
  computed: {
    isLoggedIn () {
      return store.getters['isLoggedIn']
    }
  },
  methods: {},
  mounted () {}
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoSliderItem.vue